module.exports = __webpack_public_path__ + "static/unitedkingdom-0539d02ef61b3eebe52137e134bb1751.png";